export const navigationTranslation = {
  sidebar: {
    sections: {
      store: 'navigation.sidebar.sections.store',
      contracts: 'navigation.sidebar.sections.contracts',
    },
    items: {
      home: 'navigation.sidebar.items.home',
      products: 'navigation.sidebar.items.products',
      invoices: 'navigation.sidebar.items.invoices',
      transactions: 'navigation.sidebar.items.transactions',
      storeData: 'navigation.sidebar.items.storeData',
      storeTPV: 'navigation.sidebar.items.storeTPV',
      storeContacts: 'navigation.sidebar.items.storeContacts',
      storeStickers: 'navigation.sidebar.items.storeStickers',
      contractsData: 'navigation.sidebar.items.contractsData',
      contractsProducts: 'navigation.sidebar.items.contractsProducts',
    },
  },
  header: {
    user: {
      configuration: 'navigation.header.user.configuration',
      usageConditions: 'navigation.header.user.usage_conditions',
      legal: 'navigation.header.user.legal',
      privacyPolicy: 'navigation.header.user.privacy_policy',
      cookiesPolicy: 'navigation.header.user.cookies_policy',
      usageConditionsFileName: 'navigation.header.user.usage_conditions.file',
      legalFileName: 'navigation.header.user.legal.file',
      privacyPolicyFileName: 'navigation.header.user.privacy_policy.file',
      cookiesPolicyFileName: 'navigation.header.user.cookies_policy.file',
      logout: 'navigation.header.user.logout',
      access: 'navigation.header.user.access',
    },
  },
}

export const headerNavbarTranslation = {
  myAccount: 'navbar.header.myAccount',
  help: 'navbar.header.help',
  helpSubject: 'navbar.header.help_subject',
  helpEmail: 'navbar.header.help_email',
  DropdownSearch:{
    empty:{
      line1: "navbar.header.DropdownSearch.empty.line1",
      line2: "navbar.header.DropdownSearch.empty.line2",
      lineGuarderia: "navbar.header.DropdownSearch.empty.lineGuarderia",
      email: "navbar.header.DropdownSearch.empty.email",
    },
    placeholder: "navbar.header.DropdownSearch.placeholder",
    placeholderGuarderia: "navbar.header.DropdownSearch.placeholderGuarderia",
  }
}
